import { IPrintingOrders } from '@/modules/packhouse/printingOrders/types';
import { getLocalizedDate } from '@/shared/lib/dates';
interface IProps {
  orderDetails?: IPrintingOrders.IOrderDetailsItem;
}
export const getCardData = ({ orderDetails }: IProps) => {
  const tickets = orderDetails?.numOfTickets ?? 0; // Default to 0 if undefined or null
  const workerCount = orderDetails?.workers?.length ?? 0; // Default to 0 if undefined or null

  const result = tickets * workerCount;
  return {
    // get last part of orderId
    orderId: orderDetails?.orderId?.split('-')?.slice(-1)[0] ?? '-',
    time:
      getLocalizedDate({
        date: orderDetails?.createdAt,
        formatDate: 'hh:mm a',
      }) || '-',
    'tickets (per-worker)': orderDetails?.numOfTickets ?? 0,

    'total-tickets': result,

    'workers-count': orderDetails?.workers?.length ?? 0,
  };
};
